<template>
  <div >
    <div class="sk-circle" style="margin: 20px auto 20px auto;">
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
      <div class="sk-circle-dot"></div>
    </div>
    <p class="text-center">
      Please wait ...
      <br />
      <i>
        <small>
          <b>(Your request on processed.)</b>
        </small>
      </i>
    </p>
  </div>
</template>

<script>
export default {
  name: "Loading"
};
</script>

<style>
</style>
